import { Masonry } from '@leagueplatform/masonry';
import { ENHANCED_BENEFITS_DISCLAIMER_ROOT_NODE_ID } from 'common/constants';

export const EnhancedMembersDisclaimer = () => (
  <Masonry rootNodeId={ENHANCED_BENEFITS_DISCLAIMER_ROOT_NODE_ID} />
);
